import * as React from 'react'

const useDidMount = () => {
  const [didMount, setDidMount] = React.useState(false)
  React.useEffect(() => {
    setDidMount(true)
  }, [])
  return didMount
}

export default useDidMount
